import React from 'react';
import loadable from 'Components/AsyncModuleLoader/AsyncModuleLoader';
import { FullPageLoader } from 'panamera-react-ui';

export default loadable({
    loader: () => import(/* webpackChunkName: 'UserDetailsFormWithOverlay' */'./UserDetailsFormWithOverlay'),
    loading: <FullPageLoader />
});
